import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../../utils/customBaseQuery";
import { gql } from "graphql-request";

export const AssignLearningApi = createApi({
  reducerPath: "assignLearningApi",
  baseQuery: customBaseQuery,
  keepUnusedDataFor: 60,
  endpoints: (builder) => ({
    getAssignLearningApi: builder.query({
      query: ({
        pageNumber,
        pageSize,
        requiredQuery = ` timestamp
              error
              version
              data {
                totalCount
                pageSize
                pageNumber
                searchResult {
                  attemptCount
                  progressStatus
                  progressPercentage
                  id
                  externalownerlist
                  title
                  brandingurls {
                    promo
                    thumbnail
                    banner
                  }
                  stakeholder{
                    owner
                  }
                  branding {
                    promo
                    thumbnail
                    banner
                  }
                  language
                  stakeholder {
                    owner
                    observer
                    nominationApprover
                    reviewer
                    }
                  assignedBy {
                    id
                    firstName
                    fullName
                    email
                    enabled
                    }
                  nominatedBy {
                   id
                    firstName
                    fullName
                    email
                  }
                  createdby
                  shortdescription
                  longdescription
                  sessioncount
                  modulecount
                  sectioncount
                  contentcount
                  episodecount
                  episodenumber
                  prerequisite
                  createdat
                  updatedat
                  status
                  publishedat
                  sourcename
                  sourcetype
                  artifacttype
                  weblink
                  skills {
                    type
                    skillid
                    parentskill
                    preferredskillname {
                      en_UK
                      en_US
                    }
                  }
                  searchtags {
                    defaultTag
                  }
                  joblevel
                  privateusergroup
                  startdate
                  proficiency
                  mode
                  function
                  isblocking
                  publishedby
                  maxcapacity
                  visibility
                  difficultylevel
                  registrationcost {
                    amount
                    currency
                  }
                  templateid
                  enddate
                  eventtype
                  pageno
                  location
                  contentlist
                  {
                  title
                  }
                  section
                  {
                  id
                  }
                  duration
                  artifactid
                  deadlineDate
                  expirydate
                  launchdate
                }
              }`
      }: any) => ({
        url: "/graphql",
        body: gql`
          query {
            assignLearning(
              pageNumber:${pageNumber}
              pageSize: ${pageSize}
              sortKey: "_score"
              sortOrder: "ASC"
              relevance: false
            ) {
             ${requiredQuery}
            }
          }
        `
      }),
      extraOptions: { service: "Catalog" },
      serializeQueryArgs: () => {
        return "assignLearningApi";
      },

      merge(currentCacheData, responseData, otherArgs) {
        if (otherArgs.arg?.pageNumber > 1) {
          const messageMap = new Map();
          [
            ...currentCacheData.assignLearning.data.searchResult,
            ...responseData.assignLearning.data.searchResult
          ].map((msg) => {
            if (!messageMap.has(msg.id)) {
              messageMap.set(msg.id, msg);
            }
          });
          const mergedResult = [...messageMap.values()];
          return {
            ...responseData,
            assignLearning: {
              ...responseData.assignLearning,
              data: {
                ...responseData.assignLearning.data,
                searchResult: mergedResult
              }
            }
          };
        } else return responseData;
      }
    }),
    getAssignLearningForUserId: builder.query({
      query: ({ id, pageNumber, pageSize }: any) => ({
        url: "/graphql",
        body: gql`
          query {
            assignLearningForUserId(
              userId: "${id}"
              pageNumber:${pageNumber}
              pageSize: ${pageSize}
              sortKey: "_score"
              sortOrder: "ASC"
              relevance: false
              includeEvent: true
              exclude : "COMPLETED_COURSE"
            ) {
              error
              data {
                totalCount
                pageSize
                pageNumber
                searchResult {
                  attemptCount
                  progressStatus
                  progressPercentage
                  id
                  externalownerlist
                  title
                  brandingurls {
                    promo
                    thumbnail
                    banner
                  }
                  branding {
                    promo
                    thumbnail
                    banner
                  }
                    language
                  assignedBy {
                    id
                    firstName
                    fullName
                    email
                    }
                  createdby
                  shortdescription
                  longdescription
                  sessioncount
                  modulecount
                  sectioncount
                  contentcount
                  episodecount
                  prerequisite
                  createdat
                  updatedat
                  status
                  publishedat
                  sourcename
                  sourcetype
                  artifacttype
                  weblink
                  skills {
                    type
                    skillid
                    parentskill
                    preferredskillname {
                      en_UK
                      en_US
                    }
                  }
                  searchtags {
                    defaultTag
                  }
                  joblevel
                  privateusergroup
                  startdate
                  proficiency
                  mode
                  function
                  isblocking
                  publishedby
                  maxcapacity
                  visibility
                  difficultylevel
                  registrationcost {
                    amount
                    currency
                  }
                  templateid
                  enddate
                  eventtype
                  pageno
                  location
                  contentlist
                  {
                  title
                  }
                  duration
                  artifactid
                  deadlineDate
                  expirydate
                  launchdate
                }
              }
            }
          }
        `
      }),
      extraOptions: { service: "Catalog" },
      serializeQueryArgs: ({ queryArgs }) => {
        const { id } = queryArgs;
        return `assignLearningApi-${id}`;
      },
      merge(currentCacheData, responseData, otherArgs) {
        console.log(currentCacheData, responseData, otherArgs);

        if (otherArgs.arg?.pageNumber > 1) {
          const messageMap = new Map();
          [
            ...currentCacheData.assignLearningForUserId.data.searchResult,
            ...responseData.assignLearningForUserId.data.searchResult
          ].map((msg) => {
            if (!messageMap.has(msg.id)) {
              messageMap.set(msg.id, msg);
            }
          });
          const mergedResult = [...messageMap.values()];
          return {
            ...responseData,
            assignLearningForUserId: {
              ...responseData.assignLearningForUserId,
              data: {
                ...responseData.assignLearningForUserId.data,
                searchResult: mergedResult
              }
            }
          };
        } else return responseData;
      }
    })
  })
});

export const {
  useGetAssignLearningApiQuery,
  useLazyGetAssignLearningApiQuery,
  useGetAssignLearningForUserIdQuery
} = AssignLearningApi;
